import styled from "styled-components";

const Card=styled.div`

background:linear-gradient(135deg,#1d4ed8,#2563eb);

padding:28px;

border-radius:24px;

color:white;

box-shadow:0 15px 35px rgba(0,0,0,.25);

`;

const Title=styled.h2`

margin:0 0 18px 0;

font-size:1.4rem;

`;

const Text=styled.p`

line-height:1.8;

opacity:.95;

font-size:1rem;

`;

const Impact=styled.div`

margin-top:20px;

display:inline-flex;

padding:10px 18px;

border-radius:999px;

background:rgba(255,255,255,.15);

font-weight:700;

`;

export default function DailyBriefingCard({

    tutor

}){

return(

<Card>

<Title>

🦊 Informe del Tutor

</Title>

<h3>

{tutor.titulo}

</h3>

<Text>

{tutor.fraseProfesor}

</Text>

<Impact>

🚀 {tutor.recomendacion}

</Impact>

</Card>

);

}